import { Breadcrumb, HeaderToolbar, Tooltip } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { XolaPartner } from "types";
import { ColumnLayout } from "../Layout/ColumnLayout";
import { PartnerProfile } from "./Partner/PartnerProfile";
import { NoTranslate } from "@/components/Common/NoTranslate";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";
import { useResource } from "@/hooks/useResource";
import { Page } from "@/pages/Page";

export const PartnerProfilePage = () => {
    const { id } = useParams<{ id?: string }>();
    const { data: partner } = useResource<XolaPartner>(["partners", id], { expand: "purchaseRule,partnerSeller" });
    const history = useHistory();

    const handleClickOperators = () => {
        history.push("/distribution/operators");
    };

    return (
        <Page title="Operators">
            <ColumnLayout>
                <ColumnLayout.Fill>
                    <HeaderToolbar>
                        <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                            <Breadcrumb.Item>Distribution</Breadcrumb.Item>
                            <Breadcrumb.Item onClick={handleClickOperators}>Operators</Breadcrumb.Item>
                            <NoTranslate>
                                <Tooltip content={partner?.partnerSeller.name ?? "New Operator"}>
                                    <Breadcrumb.Item>{partner?.partnerSeller?.name ?? "New Operator"}</Breadcrumb.Item>
                                </Tooltip>
                            </NoTranslate>
                        </HeaderToolbar.Breadcrumb>
                        {id && (
                            <EmbeddedAppTriggerLocation
                                id="distribution.operators.detail.headerBar"
                                context={{ partners: [{ id }] }}
                            />
                        )}
                    </HeaderToolbar>

                    <PartnerProfile partner={partner} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
